import { Flex, View } from '@adobe/react-spectrum';
import moment from 'moment';
import { truncateText } from '../../../../utils/helperUtil';
import styles from './card_component.module.css';
import { ChevronRight } from 'react-bootstrap-icons';
import { ContactIcon } from '../../../../components/protected/Icons/IconsLib';
import { useEffect, useState } from 'react';
interface ICardComponentProps {
  item: any;
  activityStatusList: any;
}

const CardComponent: React.FC<ICardComponentProps> = ({ item, activityStatusList }) => {
  const getStatusColorName = (statusName: string) => {
    //console.log('status', statusName);
    const statusObj = activityStatusList?.find((obj: any) => obj.name === statusName);
    return statusObj?.color;
  };

  function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return width;
}

const width = useWindowWidth();
let truncateLength = 35;
if (width > 1400) {
  truncateLength = 40;
} else if (width > 1200) {
  truncateLength = 25;
} else if (width > 1000) {
  truncateLength = 20;
} else if (width > 800) {
  truncateLength = 18;
} else if (width > 600) {
  truncateLength = 15;
} else if (width > 400) {
  truncateLength = 10;
} else {
  truncateLength = 25;
}

  return (
    <Flex 
    direction="column" 
    position={'absolute'} 
    width={'100%'} 
    alignItems={'start'} 
    justifyContent={'start'} 
    UNSAFE_className={styles.card_list}>
      <Flex 
      direction={'row'} 
      position={'relative'} 
      width={'100%'} 
      alignItems={'center'} 
      justifyContent={'start'} 
      UNSAFE_className={styles.card_child_wrapper}>
        <View
          position={'absolute'}
          margin={'0px'}
          height={'calc(100% - 36px)'}
          width={'4px'}
          top={'18px'}
          bottom={'18px'}
          left={'-1px'}
          maxHeight={'100%'}
          zIndex={1}
          UNSAFE_style={{ backgroundColor: +item.folderCount > 0 ? '#ff9800' : '#B0BEC5', borderRadius: '5px' }}
        />
        <Flex 
        direction={'column'} 
        width={'100%'}
        alignSelf={'stretch'}
        alignItems={'start'} 
        justifyContent={'start'} 
        gap={'10px'} zIndex={1}>
          <Flex 
          direction={'column'} 
          alignSelf={'stretch'} 
          alignItems={'start'} 
          justifyContent={'start'} gap={'12px'}>
            <Flex direction={'row'} alignItems={'center'} justifyContent={'start'} gap={'6px'} UNSAFE_className={styles.header_path_wrapper}>
              <View position={'relative'} UNSAFE_className={styles.header_path_text}>
                <View UNSAFE_className={styles.contact_info}>
                <span className={
                   +item.folderCount > 0 ?styles.contact_icon_orange:styles.contact_icon_grey
                  }><ContactIcon size={20} color={'#ff9800'} /></span>
                <span>
                  {truncateText(`${item.name3 || ''} ${item.name1 || ''}`, truncateLength)}
              </span>
                <View marginTop={10}>{item.phone}</View>
                <View marginTop={4}>{item.email}</View>
                </View>
              </View>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      <View UNSAFE_style={{ height: '10px' }} />
    </Flex>
  );
};

export default CardComponent;
